import React, { useCallback } from 'react';

import { DropdownItem } from '@atlaskit/dropdown-menu';
import { useIntl } from '@atlassian/jira-intl';
import { useCommentContext } from '../CommentContextProvider.tsx';

import messages from '../../messages.tsx';

const PinAction = ({
	handleDropdownClick,
}: {
	handleDropdownClick: (eventName: string) => void;
}) => {
	const { formatMessage } = useIntl();
	const { canPin, isPinned, isPinnedCommentsLimitReached, onPinClick, onUnpinClick } =
		useCommentContext();

	const onPinClickHandler = useCallback(() => {
		if (!onPinClick || !onUnpinClick) {
			return;
		}
		isPinned ? onUnpinClick() : onPinClick();
		handleDropdownClick('meatballMenuPinCommentButton');
	}, [onPinClick, onUnpinClick, isPinned, handleDropdownClick]);

	if (!canPin || (isPinnedCommentsLimitReached && !isPinned)) {
		return null;
	}

	const messageKey = isPinned ? messages.unpinComment : messages.pinComment;

	return (
		<DropdownItem key="pin" onClick={() => onPinClickHandler()}>
			{formatMessage(messageKey)}
		</DropdownItem>
	);
};

export default PinAction;
